var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeFilled = function SvgEyeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.001a3.999 3.999 0 1 1 0 7.998 3.999 3.999 0 0 1 0-7.998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.658c6.19 0 9.716 4.237 11.267 6.762a4.91 4.91 0 0 1 0 5.16c-1.55 2.525-5.078 6.762-11.267 6.762-6.19 0-9.717-4.237-11.267-6.762a4.91 4.91 0 0 1 0-5.16C2.283 6.895 5.81 2.658 12 2.658m0 3.344a5.998 5.998 0 0 0 0 11.995 5.998 5.998 0 0 0 0-11.995",
    clipRule: "evenodd"
  })));
};
export default SvgEyeFilled;